import * as _ from "lodash";
import axios from "axios";
import { getEnv } from "../utils/env";

export const baseURL = getEnv("REACT_APP_CHAT_SERVICE_ORIGIN");

const http = axios.create({
  baseURL,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

http.interceptors.request.use((config) => {
  const accessToken = sessionStorage.getItem("accessToken") || "";
  const timeZone = sessionStorage.getItem("timeZone") || null;

  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`;
  }

  if (timeZone) {
    config.headers["X-Time-Zone"] = timeZone;
  }

  return config;
});

http.interceptors.response.use(
  (response) => _.get(response, "data"),
  async (error) => {
    throw _.get(error, "response.data", {});
  }
);

export default http;
